import { useIsCellVisible } from "../../../../../hooks/useTimelineViewport"
import TimelineTimeStep from "./TimelineTimeStep"

type Props = {
    objectId: string
    index: number
    TimelineTimeStepWidth: number
    timelineStepX: number
}

const TimelineTimeStepWrapper = ({
    objectId,
    index,
    TimelineTimeStepWidth,
    timelineStepX,
}: Props) => {
    // keep in sync with the geometry TimelineTimeStep renders with
    const isInViewport = useIsCellVisible(index * timelineStepX + 2, TimelineTimeStepWidth)

    // Off-screen cells render nothing at all. They used to render a placeholder <div>, which
    // at 300 rows x 20 steps meant ~6 000 DOM nodes that were never visible — and style
    // recalculation over the whole document scales with the node count.
    if (!isInViewport) return null

    return (
        <TimelineTimeStep
            objectId={objectId}
            index={index}
            TimelineTimeStepWidth={TimelineTimeStepWidth}
            timelineStepX={timelineStepX}
        />
    )
}

export default TimelineTimeStepWrapper
